jQuery(document).ready(function ($) {
  // Scope to accordion block only - do not affect faq-accordion block
  const $accordionQuestions = $(".accordion .questions_and_answers .question");

  // Remove any existing event handlers to prevent duplicates
  $accordionQuestions.off("click");

  // Function to update Lenis scroll height after content changes
  function updateScrollHeight() {
    // Update Lenis if available
    if (window.SOJ_SMOOTH_SCROLL && window.SOJ_SMOOTH_SCROLL.lenis) {
      window.SOJ_SMOOTH_SCROLL.lenis.resize();
    }
    
    // Update ScrollTrigger if available
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
    
    // Trigger resize event as fallback
    window.dispatchEvent(new Event("resize"));
  }

  $accordionQuestions.on("click", function (e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling

    var $question = $(this);
    var $answer = $(this).next(".answer");

    if ($(this).hasClass("active2")) {
      $(this).removeClass("active2");
      $answer.slideUp(300, function() {
        // Update scroll height after animation completes
        updateScrollHeight();
      });
    } else {
      // Close all other questions first (accordion behavior) - scope to accordion block
      $(".accordion .questions_and_answers .question").removeClass("active2");
      $(".accordion .questions_and_answers .answer").slideUp(300);

      // Now open the clicked question
      $(this).addClass("active2");
      $answer.slideDown(300, function() {
        // Update scroll height after animation completes
        updateScrollHeight();
      });
    }
  });
});








